const languageList = require('language-list')()

export const getLanguageName = (code: string) => {
  return languageList.getLanguageName(code)
}
